import React from 'react';
import { FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { ApprovalAction, ACTION_TYPES } from '../constants';

interface ActionSelectionSectionProps {
  action: ApprovalAction;
  onActionChange: (action: ApprovalAction) => void;
  isSubmitting: boolean;
  readOnly: boolean;
}

export const ActionSelectionSection: React.FC<ActionSelectionSectionProps> = ({
  action,
  onActionChange,
  isSubmitting,
  readOnly,
}) => (
  <FormControl component="fieldset">
    <FormLabel component="legend">Action</FormLabel>
    <RadioGroup
      value={action}
      onChange={(e) => onActionChange(e.target.value as ApprovalAction)}
      row
    >
      <FormControlLabel
        value={ACTION_TYPES.APPROVE}
        control={<Radio color="success" />}
        label="Approve"
        disabled={isSubmitting || readOnly}
      />
      <FormControlLabel
        value={ACTION_TYPES.REJECT}
        control={<Radio color="error" />}
        label="Reject"
        disabled={isSubmitting || readOnly}
      />
    </RadioGroup>
  </FormControl>
);

export default ActionSelectionSection;
